import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSeatComponent } from './simple-icons-seat.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSeatComponent ],
    exports:      [ SimpleIconsSeatComponent ],
    bootstrap:    []
})
export class SimpleIconsSeatModule {}
